import React from "react";
import { formatIDR } from "@/lib/api";
import { Percent } from "lucide-react";

export const lineDisc = (l) => {
  const v = +l.disc_value || 0, base = +l.line_total || 0;
  if (v <= 0) return 0;
  return Math.min(base, Math.round(l.disc_type === "%" ? (base * v) / 100 : v));
};

export const LineDiscount = ({ l, i, onChange, amount }) => (
  <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-1 pl-6 text-[11px]" data-testid={`mq-line-disc-row-${i}`}>
    <Percent className="w-3 h-3 text-rose-500 shrink-0" />
    <span className="text-slate-500">Diskon</span>
    <select data-testid={`mq-line-disc-type-${i}`} value={l.disc_type || "%"} onChange={(e) => onChange({ disc_type: e.target.value })} className="border border-slate-200 rounded-lg px-1 py-1 bg-white">
      <option value="%">%</option>
      <option value="Rp">Rp</option>
    </select>
    <input data-testid={`mq-line-disc-value-${i}`} type="number" min="0" value={l.disc_value || ""} placeholder="0" onChange={(e) => onChange({ disc_type: l.disc_type || "%", disc_value: e.target.value })} className="w-20 border border-slate-200 rounded-lg px-1.5 py-1 text-right" />
    {amount > 0 && <span className="text-rose-600 font-medium" data-testid={`mq-line-disc-amount-${i}`}>- {formatIDR(amount)} → {formatIDR((+l.line_total || 0) - amount)}</span>}
  </div>
);
